<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b('', { deposit: isDeposit })">
    <span :class="b('direction')" aria-hidden="true">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path
          :d="isDeposit ? 'M12 5v14M6 13l6 6 6-6' : 'M12 19V5M6 11l6-6 6 6'"
        />
      </svg>
    </span>

    <div :class="b('content')">
      <p :class="b('title')">
        {{ $t(isDeposit ? "Пополнение" : "Вывод") }} · {{ currencyName }}
      </p>
      <p :class="b('date')">{{ row.created_at }}</p>
    </div>

    <p :class="b('amount', { deposit: isDeposit })">
      {{ isDeposit ? "+" : "-" }}{{ displayedAmount }}
    </p>

    <span :class="b('status', { [statusTone]: true })">
      <i></i>{{ $t(statusLabel) }}
    </span>
  </div>
</template>
